import BbsListItem from "./BbsListItem";

function BbsList({ posts, moduleName, currentPage, selectedCategory, activeId }) {
  return (
    <div className="space-y-4">
      {posts.map((item) => (
        <BbsListItem
          key={item.document_id || item.id}
          item={item}
          moduleName={moduleName}
          currentPage={currentPage}
          selectedCategory={selectedCategory}
          isActive={activeId === item.document_id}
        />
      ))}
    </div>
  );
}

export default BbsList;
